import { render, staticRenderFns } from "./Waypoint.vue?vue&type=template&id=55d22814"
import script from "./Waypoint.vue?vue&type=script&lang=js"
export * from "./Waypoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports